import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { colors, leading } from '../../styles/theme';
import * as rowVariants from './row-variants';

const ActionWrapperStandalone = css`
  margin: 15px 0 0 0;
  border-top: 0;
  padding-top: 0;
`;

export const ActionsWrapper = styled('div')`
  padding-top: ${leading.full};
  margin: ${leading.full} 0;
  border-top: 1px solid ${colors.grey.secondaryDark};
  text-align: right;
  ${(props) => props.standalone && ActionWrapperStandalone};
`;

ActionsWrapper.propTypes = {
  standalone: PropTypes.bool,
};

ActionsWrapper.defaultProps = {
  standalone: null,
};

export const Row = styled('div')`
  margin-top: ${leading.full};
  ${(props) => rowVariants[props.size]};
  &:first-of-type {
    margin-top: 0;
  }
  & + ${ActionsWrapper} {
    margin-top: 30px;
  }
`;

Row.propTypes = {
  size: PropTypes.oneOf(['tiny', 'half']),
};

Row.defaultProps = {
  size: null,
};

export const SectionDivider = styled('div')`
  border-top: 1px solid ${colors.grey.secondaryDark};
  padding: 30px 15px 0;
  margin-bottom: 30px;
  &:first-of-type {
    border-top: 0;
    padding-top: 0;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const HighlightGroup = styled('div')`
  background: ${colors.grey.secondary};
  border: 1px solid ${colors.grey.secondaryDark};
  padding: ${leading.full} 15px;
  border-radius: 3px;
`;
